import { RpcErrorCode } from '../../errors/rpc.js';
import { urlWithParams } from '../../utils/url.js';
export const getBalance = async (client, { baseUrl, apiKey }, { address }) => {
    const apiUrl = urlWithParams(`${baseUrl}/addresses/balances`, {
        key: apiKey,
        addresses: address,
    });
    const response = (await client.request({
        url: apiUrl,
        fetchOptions: { method: 'GET' },
    }));
    if (response.data[address] === undefined ||
        response.context.error ||
        response.context?.code !== 200) {
        return {
            error: {
                code: response.context.code === 429
                    ? RpcErrorCode.ACCESS_DENIED
                    : RpcErrorCode.MISC_ERROR,
                message: response.context?.error,
            },
        };
    }
    return {
        result: BigInt(response.data[address]),
    };
};
//# sourceMappingURL=getBalance.js.map